import { render, staticRenderFns } from "./RoutesOut.vue?vue&type=template&id=9669d2fa"
import script from "./RoutesOut.vue?vue&type=script&lang=js"
export * from "./RoutesOut.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports